/* User defined models */
import { ProSchedulerDropdown } from './dropdown.model';

export class DynamicFormBase<T>{
  value: T;
  key: string;
  label: string;
  alternativeLabel: string;
  private _required: boolean;
  order: number;
  controlType: string;
  maxlength: number;
  minlength: number;
  length: number;
  pattern: string;
  children: DynamicFormBase<T>[];
  parent: ProSchedulerDropdown;
  validationMessage: string;
  placeholder: string;
  validationData: string;
  error: string;
  readOnly: boolean;
  fieldMap: string;
  displayFlag: boolean;
  values: any;

  constructor(options: {
    value?: T,
    key?: string,
    label?: string,
    alternativeLabel?: string,
    required?: boolean,
    order?: number,
    controlType?: string,
    maxlength?: number,
    minlength?: number,
    length?: number,
    pattern?: string,
    validationMessage?: string,
    placeholder?: string,
    validationData?: string,
    error?: string,
    readOnly?: boolean,
    fieldMap?: string,
    displayFlag?: boolean
  } = {}) {
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.alternativeLabel = options.alternativeLabel || '';
    this._required = !!options.required;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.maxlength = options.maxlength || 0;
    this.minlength = options.minlength || 0;
    this.length = options.length || 0;
    this.pattern = options.pattern || '';
    this.validationMessage = options.validationMessage || '';
    this.placeholder = options.placeholder || '';
    this.validationData = options.validationData;
    this.error = options.error || '';
    this.readOnly = options.readOnly;
    this.fieldMap = options.fieldMap || '';
    this.displayFlag = options.displayFlag;
    this.children = [];
  }

  setValue(value: T) {
    this.value = value;
  }

  setParent(parent: ProSchedulerDropdown): void {
    this.parent = parent;
  }

  setChildren(children: DynamicFormBase<T>[]): void {
    this.children = children;
  }

  get parentRequiresChild(): boolean {
    return !!this.parent && this.parent.valueRequiresChildren;
  }

  get required(): boolean {
    return this._required || this.parentRequiresChild;
  }

  set required(required: boolean) {
    this._required = required;
  }
}
